import { atom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';

import type { AuthProps } from '../components/pique/auth';
import type { SettingProps } from '../components/pique/setting-modal';
import { DEFAULT_SETTING_TAB } from '../components/pique/setting-modal/types';
import type { ActiveTab } from '../components/pique/setting-modal/types';
// modal atoms
export const openWorkspacesModalAtom = atom(false);
export const openSignOutModalAtom = atom(false);
export const openQuotaModalAtom = atom(false);
export const openIssueFeedbackModalAtom = atom(false);
export const openHistoryTipsModalAtom = atom(false);
export const openInfoModalAtom = atom(false);

export const rightSidebarWidthAtom = environment.isTauri ? atom(440) : atom(530);

export type PlansScrollAnchor =
  | 'aiPricingPlan'
  | 'cloudPricingPlan'
  | 'lifetimePricingPlan';
export type SettingAtom = {
  open: boolean;
  workspaceMetadata?: SettingProps['workspaceMetadata'];
} & (
    | {
      activeTab: 'plans';
      scrollAnchor?: PlansScrollAnchor;
    }
    | { activeTab: Exclude<ActiveTab, 'plans'> }
  );

export const openSettingModalAtom = atom<SettingAtom>({
  activeTab: DEFAULT_SETTING_TAB,
  open: false,
});

export type AuthAtom = {
  openModal: boolean;
  state: AuthProps['state'];
};

export const authAtom = atom<AuthAtom>({
  openModal: false,
  state: 'signIn',
});

export const openWorkspaceListModalAtom = atom(false);

export const openTrashModalAtom = atom(false);

export type ActionItemsAssigneeMode = 'me' | 'all';
export const actionItemsAssigneeModeAtom = atomWithStorage<ActionItemsAssigneeMode>(
  'actionItemsAssigneeMode',
  'all'
);

export type ActionItemsHeaderMode = 'addItem' | 'chart';
export const actionItemsHeaderModeAtom = atom<ActionItemsHeaderMode>('addItem');

export const pendingFocusItemIdAtom = atom<string | null>(null);

export type FocusZoneDisplayMode = 'calendar' | 'list';
export const focusZoneDisplayModeAtom = atomWithStorage<FocusZoneDisplayMode>(
  'focusZoneDisplayMode',
  'list'
);

export type PreReadingModalAtom = {
  open: boolean;
  eventId: string | null;
  workspaceId: string | null;
  summary: string | null;
  description: string | null;
  location: string | null;
  startTime: string | null;
  endTime: string | null;
  timeZone: string | null;
  hangoutLink: string | null;
  attendees: unknown[] | null;
  conferenceData: unknown | null;
  calendarId: string | null;
  source: string | null;
  recurringEventId: string | null;
};

export const preReadingModalAtom = atom<PreReadingModalAtom>({
  open: false,
  eventId: null,
  workspaceId: null,
  summary: null,
  description: null,
  location: null,
  startTime: null,
  endTime: null,
  timeZone: null,
  hangoutLink: null,
  attendees: null,
  conferenceData: null,
  calendarId: null,
  source: null,
  recurringEventId: null,
});
